module.exports = __webpack_public_path__ + "img/ordF5.24dc65d1.jpg";